import { render, staticRenderFns } from "./AutoEstudios.vue?vue&type=template&id=7666fe1d&"
import script from "./AutoEstudios.vue?vue&type=script&lang=js&"
export * from "./AutoEstudios.vue?vue&type=script&lang=js&"
import style0 from "./AutoEstudios.vue?vue&type=style&index=0&id=7666fe1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports